import { ContentAdmin } from "@/models/user-model";
import { AccountService } from "@/services";
import { getEmptyPaginationResponse } from "@/util/func";
import { RoleName, store } from "commonui";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true, dynamic: true, store: store, name: "test" })
class User extends VuexModule {
	public contentAdmins: ContentAdmin[] = [];
	public selectedAdmin: string = ""; // Used when anyone clicks on name of content admin
	public loading: boolean = true;

	@Mutation
	setSelectedAdmin(adminId: string) {
		this.selectedAdmin = adminId;
	}

	@Mutation
	setContentAdmins(admins: any[]): void {
		this.contentAdmins = admins;
	}

	@Mutation
	setLoading(val: boolean): void {
		this.loading = val;
	}

	// @Action
	// callIncrement() {
	// 	console.log("store");
	// 	this.context.commit("increment", 1);
	// 	// return store.count
	// }

	//@MutationAction({ mutate: ["contentAdmins", "loading"] })
	@Action
	public async getContentAdministrators(params?: any) {
		try {
			this.setLoading(true);
			const contentAdmins = await AccountService.getUsers({
				role: RoleName.contentAdmin,
				disabled: false,
				includePendingInvite: true,
				...params
			});

			this.setContentAdmins(contentAdmins.data);
			this.setLoading(false);
			return contentAdmins;
		} catch (error) {
			return getEmptyPaginationResponse();
		}
	}

	get getContentAdmins() {
		return this.contentAdmins;
	}

	get isLoading() {
		return this.loading;
	}
}
export default User;
